module.exports = __webpack_public_path__ + "static/media/persistent.79734e53.png";